import { Button, Menu } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import {SpeedOutlined,DescriptionOutlined,AccountTreeOutlined,ManageAccountsOutlined,SettingsOutlined} from "@mui/icons-material";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import RemoveFromQueueIcon from '@mui/icons-material/RemoveFromQueue';
import ShopTwoOutlinedIcon from "@mui/icons-material/ShopTwoOutlined";
import InventoryIcon from "@mui/icons-material/Inventory";    
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import FoodBankIcon from '@mui/icons-material/FoodBank';
import SettingsBrightnessIcon from "@mui/icons-material/SettingsBrightness";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import QrCodeScannerOutlinedIcon from "@mui/icons-material/QrCodeScannerOutlined";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import SecurityIcon from "@mui/icons-material/Security";
import LoyaltyIcon from "@mui/icons-material/Loyalty"; // Added for CRM
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';

import { useSelector } from 'react-redux';
import { get_check_out } from '../Modules/Sales/Billing/newBillingSlice';
import store from '../../Redux/store';
const SideMenuUpdated = () => {

    const sideMenuRef=useRef(null)
    const userRole = useSelector((state) => state.userRoleSlice.value);
    const loginResponse = useSelector((state) => state.loginResponseSlice.value);
    const permission=useSelector((state)=>state.viewRolesAndPermissionSlice.employeePermission)
    // const {permission}=loginResponse
    const inventorySettingsConfigurationList = useSelector((state) => state.inventoryConfigSettingSlice.apiResList);
  // console.log(permission);
  
    const [collapsed, setCollapsed] = useState(true);

    const items = [
      permission?.dashboard &&
        {
          key: '/userdashboard/dashboardhome',
          icon: <SpeedOutlined/>,
          label: 'Dashboard',
          path: '/userdashboard/dashboardhome',
          // disabled:!permission?.dashboard
        },
        permission?.products &&
        {
          key: '/userdashboard/productList',
          icon: <RemoveFromQueueIcon/>,
          label: 'Products',
          path: '/userdashboard/productList',
          // disabled:!permission?.products
        },

        {
          key: 'pointOfSale',
          label: 'Point Of Sales',
          icon: <PointOfSaleIcon/>,
          onTitleClick: () => navigate('/userdashboard/timeSalesReport/timeSalesReport'),
          children: [
            (permission?.pointOfSales?.billing || userRole==="admin") &&
            {
              key: '/userdashboard/pos/billingnew',
              label: 'Billing',
              path: '/userdashboard/pos/billingnew',
              // disabled: (!permission?.pointOfSales?.billing || userRole==="admin")
            },
            permission?.pointOfSales?.specialItems &&
            {
              key: '/userdashboard/pos/specialItems',
              label: 'Special Items',
              path: '/userdashboard/pos/specialItems',
              // disabled: (!permission?.pointOfSales?.specialItems)
            },
            {
              key: 'posGeneral',
              label: 'General',
              children:[
                permission?.pointOfSales?.general?.shift &&
                {
                  key: '/userdashboard/pointOfSales/general/shift',
                  label: 'Shift',
                  path: '/userdashboard/pointOfSales/general/shift',
                  // disabled: (!permission?.pointOfSales?.general?.shift)
                },
                permission?.pointOfSales?.general?.orders &&
                {
                  key: '/userdashboard/pointOfSales/general/orders',
                  label: 'Orders',
                  path: '/userdashboard/pointOfSales/general/orders',
                  // disabled: (!permission?.pointOfSales?.general?.orders)
                },
                permission?.pointOfSales?.general?.payments &&
                {
                  key: '/userdashboard/pointOfSales/general/payments',
                  label: 'Payments',
                  path: '/userdashboard/pointOfSales/general/payments',
                  // disabled: (!permission?.pointOfSales?.general?.payments)
                },
                permission?.pointOfSales?.general?.wallet &&
                {
                  key: '/userdashboard/pointOfSales/general/wallet',
                  label: 'Wallet',
                  path: '/userdashboard/pointOfSales/general/wallet',
                  // disabled: (!permission?.pointOfSales?.general?.wallet)
                }
              ].filter(Boolean),
            },
            {
              key: 'posReport',
              label: 'Report',
              children:[
                permission?.pointOfSales?.report?.shiftReport &&
                {
                  key: '/userdashboard/pointOfSales/report/shiftReport',
                  label: 'Shift Report',
                  path: '/userdashboard/pointOfSales/report/shiftReport',
                  // disabled: (!permission?.pointOfSales?.report?.shiftReport)
                },

                {
                  key: '/userdashboard/PointOfSales/report/shiftReportnew',
                  label: 'Advanced Shift Report',
                  path: '/userdashboard/PointOfSales/report/shiftReportnew',
                  // disabled: (!permission?.PointOfSales?.report?.shiftReportNew)
                },
                permission?.pointOfSales?.report?.shiftSummaryReport &&
                {
                  key: '/userdashboard/pointOfSales/report/shiftSummaryReport',
                  label: 'Shift Summary Report',
                  path: '/userdashboard/pointOfSales/report/shiftSummaryReport',
                  //  disabled: (!permission?.pointOfSales?.report?.shiftSummaryReport)
                },
                permission?.pointOfSales?.report?.salesDetails &&
                {
                  key: '/userdashboard/pointOfSales/report/salesDetails',
                  label: 'Sales Details',
                  path: '/userdashboard/pointOfSales/report/salesDetails',
                  // disabled: (!permission?.pointOfSales?.report?.salesDetails)
                },
                permission?.pointOfSales?.report?.aggregatorReport &&
                {
                  key: '/userdashboard/pointOfSales/report/aggregatorReport',
                  label: 'Aggregator Report',
                  path: '/userdashboard/pointOfSales/report/aggregatorReport',
                  // disabled: (!permission?.pointOfSales?.report?.aggregatorReport)
                },
                permission?.pointOfSales?.report?.cashcardSummary &&
                {
                  key: '/userdashboard/pointOfSales/report/DailyCashCardSummary',
                  label: 'Daily Cash/Card Summary',
                  path: '/userdashboard/pointOfSales/report/DailyCashCardSummary',
                  // disabled: (!permission?.pointOfSales?.report?.cashcardSummary
                  // )
                },
                permission?.pointOfSales?.report?.cashcardSummary &&
                {
                  key: '/userdashboard/pointOfSales/report/PosSalesSummery',
                  label: 'Sales Summary',
                  path: '/userdashboard/pointOfSales/report/PosSalesSummery',
                  // disabled: (!permission?.pointOfSales?.report?.cashcardSummary
                  // )
                },
              ].filter(Boolean),
            },
            // {
            //   key: '/userdashboard/timeSalesReport/timeSalesReport',
            //   label: 'Time Sales Report',
            //   path: '/userdashboard/timeSalesReport/timeSalesReport',
            // },
            {
              key:'posExpense',
              label:'Expense',
              children:[
                permission?.pointOfSales?.expense?.staffExpense &&
                {
                  key: '/userdashboard/Expense/staffExpense',
                  label: 'Staff Expense',
                  path: '/userdashboard/Expense/staffExpense',
                  // disabled: (!permission?.pointOfSales?.expense?.staffExpense)
                },
                permission?.pointOfSales?.expense?.outletExpense &&
                {
                  key: '/userdashboard/Expense/outletExpense',
                  label: 'Outlet Expense',
                  path: '/userdashboard/Expense/outletExpense',
                  // disabled: (!permission?.pointOfSales?.expense?.outletExpense)
                },
                permission?.pointOfSales?.expense?.addExpenseType &&
                {
                  key: '/userdashboard/Expense/addExpenseType',
                  label: 'Add Expense Type',
                  path: '/userdashboard/Expense/addExpenseType',
                  // disabled: (!permission?.pointOfSales?.expense?.addExpenseType)
                },
                (permission?.pointOfSales?.expense?.pettycashReceipt || !userRole==="admin") &&
                {
                  key: '/userdashboard/Expense/pettyCashReceipt',
                  label: 'Petty Cash Receipt',
                  path: '/userdashboard/Expense/pettyCashReceipt',
                  // disabled: (!permission?.pointOfSales?.expense?.pettycashReceipt || !userRole==="admin")
                },
              ].filter(Boolean),
            },
            permission?.pointOfSales?.kot &&
            {
              key: '/userdashboard/kitchenOrderTicket',
              label: 'Kitchen Order Ticket',
              path: '/userdashboard/kitchenOrderTicket',
              // disabled: (!permission?.pointOfSales?.kot)
            },
            {
              key: '/userdashboard/deliveryCounter',
              label: 'Delivery Counter',
              path: '/userdashboard/deliveryCounter',
              // disabled: (!permission?.pointOfSales?.kot)
            },
            permission?.pointOfSales?.customerDisplay &&
            {
              key: '/userdashboard/customerDisplay',
              label: 'Customer Display',
              path: '/userdashboard/customerDisplay',
              // disabled: (!permission?.pointOfSales?.customerDisplay)
            },
            permission?.pointOfSales?.tokenDisplay &&
            {
              key: '/userdashboard/tokenDisplay',
              label: 'Token Display',
              path: '/userdashboard/tokenDisplay',
              // disabled: (!permission?.pointOfSales?.tokenDisplay)
            },
            permission?.pointOfSales?.floorManagement &&
            {
              key: '/userdashboard/floorManagement',
              label: 'Floor Management',
              path: '/userdashboard/floorManagement',
              // disabled: (!permission?.pointOfSales?.floorManagement)
            },
            {
              key:'posConfiguration',
              label:'Configuration',
              children:[
                permission?.pointOfSales?.configuration?.settings &&
                {
                  key: '/userdashboard/pointOfSales/configuration/settings',
                  label: 'Settings',
                  path: '/userdashboard/pointOfSales/configuration/settings',
                  // disabled:!permission?.pointOfSales?.configuration?.settings
                },
                permission?.pointOfSales?.configuration?.branchSettings &&
                {
                  key: '/userdashboard/pointOfSales/configuration/BranchSettings',
                  label: 'Branch Settings',
                  path: '/userdashboard/pointOfSales/configuration/BranchSettings',
                  // disabled:!permission?.pointOfSales?.configuration?.branchSettings
                },
                permission?.pointOfSales?.configuration?.aggregator &&
                {
                  key: '/userdashboard/pointOfSales/configuration/Aggregator',
                  label: 'Aggregator',
                  path: '/userdashboard/pointOfSales/configuration/Aggregator',
                  // disabled:!permission?.pointOfSales?.configuration?.aggregator
                }
              ]
            }
          ].filter(Boolean),
        },
        {
          key: 'purchaseManager',
          icon: <ShopTwoOutlinedIcon/>,
          label: 'Purchase',
          children:[
            permission?.purchase?.rfq &&
            {
              key: '/userdashboard/purchaseManager/RequestForQuatation',
              label: 'Request For Quotation',
              path: '/userdashboard/purchaseManager/RequestForQuatation',
              // disabled: !permission?.purchase?.rfq

            },
            permission?.purchase?.purchaseOrder &&
            {
              key: '/userdashboard/purchaseManager/NewPurchaseOrder',
              label: 'Purchase Order',
              path: '/userdashboard/purchaseManager/NewPurchaseOrder',
              // disabled: !permission?.purchase?.purchaseOrder
            },
            permission?.purchase?.grn &&
            {
              key: '/userdashboard/purchaseManager/GoodsReceivedNote',
              label: 'Goods Received Note',
              path: '/userdashboard/purchaseManager/GoodsReceivedNote',
              // disabled: !permission?.purchase?.grn
            },
            permission?.purchase?.uom &&
            {
              key: '/userdashboard/purchaseManager/unitOfMeasurment',
              label: 'Unit Of Measurement',
              path: '/userdashboard/purchaseManager/unitOfMeasurment',
              // disabled: !permission?.purchase?.uom
            },
            {
              key: '/userdashboard/purchaseManager/vendor/vendors',
              label: 'Vendors',
              path: '/userdashboard/purchaseManager/vendor/vendors',
              disabled: !permission?.purchase?.vendors
            },
            permission?.purchase?.configuration &&
            {
              key: '/userdashboard/purchaseManager/configuration',
              label: 'Configuration',
              path: '/userdashboard/purchaseManager/configuration',
              // disabled: !permission?.purchase?.configuration
            },
            permission?.purchase?.purchaseReport  &&
            {
              key: '/userdashboard/purchaseManager/PurchaseReport/PurchaseReportNew',
              label: 'Purchase Report',
              path: '/userdashboard/purchaseManager/PurchaseReport/PurchaseReportNew',
              // disabled: !permission?.purchase?.purchaseReport 
            }
          ].filter(Boolean),
        },
        {
          key: 'inventory',
          icon: <InventoryIcon/>,
          label: 'Inventory',
          children:[
            {
              key: 'inventoryProduct',
              label: 'Products',
              children:[
                (permission?.inventory?.products?.productMaster
                  || inventorySettingsConfigurationList?.productVarient) &&
                {
                  key: '/userdashboard/inventory/products/productmaster',
                  label: 'Product Master',
                  path: '/userdashboard/inventory/products/productmaster',
                  // disabled:(!permission?.inventory?.products?.productMaster
                  //   || !inventorySettingsConfigurationList?.productVarient)
                },
                permission?.inventory?.products?.product &&
                {
                  key: '/userdashboard/inventory/products/product',
                  label: 'Product',
                  path: '/userdashboard/inventory/products/product',
                  // disabled:(!permission?.inventory?.products?.product)
                }
              ].filter(Boolean),
            },
            {
              key:'inventoryOperations',
              label:'Operations',
              children:[
                (permission?.inventory?.operations?.internalTransfer|| inventorySettingsConfigurationList?.multiLocation) &&
                {
                  key: '/userdashboard/inventory/operation/Interanltransfer',
                  label: 'Internal Transfer',
                  path: '/userdashboard/inventory/operation/Interanltransfer',
                  // disabled:(!permission?.inventory?.operations?.internalTransfer|| !inventorySettingsConfigurationList?.multiLocation)
                },
                permission?.inventory?.operations?.branchTransfer &&
                {
                  key: '/userdashboard/inventory/operation/branchtransfer',
                  label: 'Branch Transfer',
                  path: '/userdashboard/inventory/operation/branchtransfer',
                  // disabled:(!permission?.inventory?.operations?.branchTransfer)
                },
                permission?.inventory?.operations?.branchReciept &&
                {
                  key: '/userdashboard/inventory/operation/branchreceipt',
                  label: 'Branch Receipt',
                  path: '/userdashboard/inventory/operation/branchreceipt',
                  // disabled:(!permission?.inventory?.operations?.branchReciept  )
                },
                permission?.inventory?.operations?.stockMoves &&
                {
                  key: '/userdashboard/inventory/operation/stockmoves',
                  label: 'Stock Moves',
                  path: '/userdashboard/inventory/operation/stockmoves',

                  // disabled:(!permission?.inventory?.operations?.stockMoves)

                },
                permission?.inventory?.operations?.inventoryAdjustments &&
                {
                  key: '/userdashboard/inventory/operation/inventoryAdjustment',
                  label: 'Inventory Adjustment',
                  path: '/userdashboard/inventory/operation/inventoryAdjustment',
                  // disabled:(!permission?.inventory?.operations?.inventoryAdjustments)
                },
                {
                  key: '/userdashboard/inventory/operation/physicalClosing',
                  label: 'Physical Closing Entry',
                  path: '/userdashboard/inventory/operation/physicalClosing',
                }
              ].filter(Boolean),
            },
            {
              key:'inventoryReport',
              label:'Reports',
              children:[
                permission?.inventory?.reports?.stockMoveReport &&
                {
                  key: '/userdashboard/inventory/reports/stockMove',
                  label: 'Stock Move',
                  path: '/userdashboard/inventory/reports/stockMove',
                  // disabled:(!permission?.inventory?.reports?.stockMoveReport)
                },
                {
                  key: '/userdashboard/inventory/reports/iaReport',
                  label: 'I A Report',
                  path: '/userdashboard/inventory/reports/iaReport',
                  // disabled:(!permission?.inventory?.reports?.stockMoveReport)
                }
                
              ].filter(Boolean),
            },
            {
              key:'inventoryConfiguration',
              label:'Configuration',
              children:[
                permission?.inventory?.configuration?.warehouse &&
                {
                  key: '/userdashboard/inventory/configuration/warehouse',
                  label: 'Ware House',
                  path: '/userdashboard/inventory/configuration/warehouse',
                  // disabled:(!permission?.inventory?.configuration?.warehouse)
                },
                permission?.inventory?.configuration?.location &&
                {
                  key: '/userdashboard/inventory/configuration/location',
                  label: 'Location',
                  path: '/userdashboard/inventory/configuration/location',
                  // disabled:(!permission?.inventory?.configuration?.location)
                },
                permission?.inventory?.configuration?.attribute &&
                {
                  key: '/userdashboard/inventory/configuration/attribute',
                  label: 'Attribute',
                  path: '/userdashboard/inventory/configuration/attribute',
                  // disabled:(!permission?.inventory?.configuration?.attribute)
                },
                permission?.inventory?.configuration?.category &&
                {
                  key: '/userdashboard/inventory/configuration/category',
                  label: 'Category',
                  path: '/userdashboard/inventory/configuration/category',
                  // disabled:(!permission?.inventory?.configuration?.category)
                },
                permission?.inventory?.configuration?.poscategory &&
                {
                  key: '/userdashboard/inventory/configuration/poscategory',
                  label: 'POS Category',
                  path: '/userdashboard/inventory/configuration/poscategory',
                  // disabled:(!permission?.inventory?.configuration?.poscategory)
                },
                permission?.inventory?.configuration?.settings &&
                {
                  key: '/userdashboard/inventory/configuration/settings',
                  label: 'Settings',
                  path: '/userdashboard/inventory/configuration/settings',
                  disabled:(!permission?.inventory?.configuration?.settings)
                }
              ].filter(Boolean),
            }
          ]
        },
        {
          key: 'sales',
          icon: <ShoppingCartIcon/>,
          label: 'Sales',
          children:[
            permission?.sales?.quotation &&
            {
              key:'/userdashboard/sales/orders/quotation',
              label: 'Quotation',
              path: '/userdashboard/sales/orders/quotation',
              // disabled:!permission?.sales?.quotation
              },
              permission?.sales?.salesOrder &&
            {
              key: '/userdashboard/sales/orders/salesOrder',
              label: 'Sales Order',
              path: '/userdashboard/sales/orders/salesOrder',
              // disabled:!permission?.sales?.salesOrder
            },
            permission?.sales?.deliveryNote &&
            {
              key: '/userdashboard/sales/orders/deliveryNote',
              label: 'Delivery Note',
              path: '/userdashboard/sales/orders/deliveryNote',
              // disabled:!permission?.sales?.deliveryNote
            },
            permission?.sales?.customers &&
            {
              key: '/userdashboard/sales/orders/customers',
              label: 'Customers',
              path: '/userdashboard/sales/orders/customers',
              // disabled:!permission?.sales?.customers
              
            },
            {
              key:`salesReport`,
              label:'Report',
              children:[
                permission?.sales?.report?.salesReport &&
                {
                  key: '/userdashboard/sales/Report/salesReport',
                  label: 'Sales Report',
                  path: '/userdashboard/sales/Report/salesReport',
                  // disabled:!permission?.sales?.report?.salesReport
                },
                permission?.sales?.report?.salesReportBySalesPerson &&
                {
                  key: '/userdashboard/sales/Report/salesReportBySalesPerson',
                  label: 'Sales Report By Sales Person',
                  path: '/userdashboard/sales/Report/salesReportBySalesPerson',
                  // disabled:!permission?.sales?.report?.salesReportBySalesPerson

                }
              ]

            }
          ].filter(Boolean),
        },
        {
          key: 'foodManagement',
          icon: <FoodBankIcon/>,
          label: 'Food Management',
          children:[
            permission?.foodManagement?.preperation &&        
            {
              key: '/userdashboard/foodManagement/preperation',
              label: 'Preperation',
              path: '/userdashboard/foodManagement/preperation',
              // disabled:!permission?.foodManagement?.preperation              
            },
            permission?.foodManagement?.recipe &&
            {
              key: '/userdashboard/foodManagement/recipe',
              label: 'Recipe',
              path: '/userdashboard/foodManagement/recipe',
              // disabled:!permission?.foodManagement?.recipe     
            },
            permission?.foodManagement?.configuration &&
            {
              key: '/userdashboard/foodManagement/configuration',
              label: 'Configuration',
              path: '/userdashboard/foodManagement/configuration',
              // disabled:!permission?.foodManagement?.configuration
     
            }
          ].filter(Boolean),
        },
        {
          key:'report',
          label:'Report',
          icon:<DescriptionOutlined/>,
          children:[
            permission?.report?.stockreport &&
            {
              key: '/userdashboard/report/stockReport',
              label: 'Stock Report',
              path: '/userdashboard/report/stockReport',
              // disabled:!permission?.report?.stockreport
             },
             permission?.report?.expenseReport &&
            {
              key: '/userdashboard/report/expenseReport',
              label: 'Expense Report',
              path: '/userdashboard/report/expenseReport',
              disabled:!permission?.report?.expenseReport
            }
          ].filter(Boolean),
        },
        {
          key:'accounts',
          label:'Accounts',
          icon:<AccountTreeOutlined/>,
          children:[
            permission?.accounts?.dashboard &&
            {
              key: '/userdashboard/accounts/',
              label: 'Dashboard',
              path: '/userdashboard/accounts/',
              // disabled:!permission?.accounts?.dashboard
              
            },
            {
              key: 'accountsCustomer',
              label: 'Customers',
              children:[
                permission?.accounts?.customers?.customerInvoice &&
                {
                  key: '/userdashboard/accounts/customers/customerInvoices',
                  label: 'Customer Invoices',
                  path: '/userdashboard/accounts/customers/customerInvoices',
                  // disabled:!permission?.accounts?.customers?.customerInvoice
                  
                },
                permission?.accounts?.customers?.saleswoso &&
                {
                  key: '/userdashboard/accounts/customers/saleswso',
                  label: 'Sales W/SO',
                  path: '/userdashboard/accounts/customers/saleswso',
                  // disabled:!permission?.accounts?.customers?.saleswoso
                },
                permission?.accounts?.customers?.payments &&
                {
                  key: '/userdashboard/accounts/customer/payments',
                  label: 'Payments',
                  path: '/userdashboard/accounts/customer/payments',
                  // disabled:!permission?.accounts?.customers?.payments

                },
                permission?.accounts?.customers?.creditNotes &&
                {
                  key: '/userdashboard/accounts/customers/creditNotes',
                  label: 'Credit Notes',
                  path: '/userdashboard/accounts/customers/creditNotes',
                  // disabled:!permission?.accounts?.customers?.creditNotes
                },
                permission?.accounts?.customers?.customers &&
                {
                  key: '/userdashboard/accounts/customers/customers',
                  label: 'Customers',
                  path: '/userdashboard/accounts/customers/customers',
                  // disabled:!permission?.accounts?.customers?.customers
                }
              ].filter(Boolean),
            },
            {
              key: 'accountsVendor',
              label: 'Vendor',
              children:[
                permission?.accounts?.vendor?.vendorBills &&
                {
                  key: '/userdashboard/accounts/vendor/vendorBills',
                  label: 'Vendor Bills',
                  path: '/userdashboard/accounts/vendor/vendorBills',
                  // disabled:!permission?.accounts?.vendor?.vendorBills
                },
                permission?.accounts?.vendor?.purchasewpo  &&
                {
                  key: '/userdashboard/accounts/vendor/purchasewopo',
                  label: 'Purchase W/PO',
                  path: '/userdashboard/accounts/vendor/purchasewopo',
                  // disabled:!permission?.accounts?.vendor?.purchasewpo  
                },
                permission?.accounts?.vendor?.payments &&
                {
                  key: '/userdashboard/accounts/vendor/payments',
                  label: 'Payments',
                  path: '/userdashboard/accounts/vendor/payments',
                  // disabled:!permission?.accounts?.vendor?.payments
                  
                },
                permission?.accounts?.vendor?.debitNotes &&
                {
                  key: '/userdashboard/accounts/vendor/DebitNotes',
                  label: 'Debit Notes',
                  path: '/userdashboard/accounts/vendor/DebitNotes',
                  // disabled:!permission?.accounts?.vendor?.debitNotes
                },
                permission?.accounts?.vendor?.vendors &&
                {
                  key: '/userdashboard/accounts/vendor/vendors',
                  label: 'Vendors',
                  path: '/userdashboard/accounts/vendor/vendors',
                  // disabled:!permission?.accounts?.vendor?.vendors
                }
              ].filter(Boolean),
            },
            {
              key:'accountsAccounting',
              label: 'Accounting',
              children:[
                permission?.accounts?.accounting?.journal &&
                {
                  key:'/userdashboard/accounts/accounting/journal',
                  label: 'Journal',
                  path: '/userdashboard/accounts/accounting/journal',
                  // disabled:!permission?.accounts?.accounting?.journal
                  
                },
                permission?.accounts?.accounting?.chartofaccounts &&
                {
                  key: '/userdashboard/accounts/accounting/chartofaccounts',
                  label: 'Chart Of Account',
                  path: '/userdashboard/accounts/accounting/chartofaccounts',
                  // disabled:!permission?.accounts?.accounting?.chartofaccounts
                },
                permission?.accounts?.accounting?.openingBalance &&
                {
                  key: '/userdashboard/accounts/accounting/openingBalance',
                  label: 'Opening Balance',
                  path: '/userdashboard/accounts/accounting/openingBalance',
                  // disabled:!permission?.accounts?.accounting?.openingBalance
                },
                permission?.accounts?.accounting?.journalEntries &&
                {
                  key: '/userdashboard/accounts/accounting/journalEntries',
                  label: 'Journal Entries',
                  path: '/userdashboard/accounts/accounting/journalEntries',
                  // disabled:!permission?.accounts?.accounting?.journalEntries
                }
              ].filter(Boolean), 
            },
            {
              key:'accountsReconcilation',
              label: 'Reconcilation',
              children:[
                permission?.accounts?.reconcilation?.bankReconcilation &&
                {
                  key: '/userdashboard/accounts/Reconciliation/BankReconciliation',
                  label: 'Bank Reconciliation',
                  path: '/userdashboard/accounts/Reconciliation/BankReconciliation',
                  // disabled:!permission?.accounts?.reconcilation?.bankReconcilation
                  
                }
              ].filter(Boolean),
            },
            {
              key:'accountsVatReport',
              label: 'VAT Report',
              children:[
                permission?.accounts?.vatreport?.inputoroutputreport &&
                {
                  key: '/userdashboard/accounts/vatReport/inputOrOutputReport',
                  label: 'Input / Output Report',
                  path: '/userdashboard/accounts/vatReport/inputOrOutputReport',
                  // disabled:!permission?.accounts?.vatreport?.inputoroutputreport
                }
              ].filter(Boolean),
            },
            {
              key: 'accountsReport',
              label: 'Reports',
              children:[
                {
                  key: 'accountsReportFinancialReports',
                  label: 'Financial Reports',
                  children:[
                    permission?.accounts?.report?.financialReport?.trialBalance &&
                    {
                      key: '/userdashboard/accounts/report/financialReport/trialbalance',
                      label: 'Trial Balance',
                      path: '/userdashboard/accounts/report/financialReport/trialbalance',
                      // disabled:!permission?.accounts?.report?.financialReport?.trialBalance
                    },
                    permission?.accounts?.report?.financialReport?.balanceSheet &&
                    {
                      key: '/userdashboard/accounts/report/financialReport/balancesheet',
                      label: 'Balance Sheet',
                      path: '/userdashboard/accounts/report/financialReport/balancesheet',
                      // disabled:!permission?.accounts?.report?.financialReport?.balanceSheet
                    },
                    permission?.accounts?.report?.financialReport?.generalLedger &&
                    {
                      key: '/userdashboard/accounts/report/financialReport/generalLedger',
                      label: 'General Ledger',
                      path: '/userdashboard/accounts/report/financialReport/generalLedger',
                      // disabled:!permission?.accounts?.report?.financialReport?.generalLedger
                    },
                    permission?.accounts?.report?.financialReport?.profitAndLoss &&
                    {
                      key: '/userdashboard/accounts/report/financialReport/Profit&Loss',
                      label: 'Profit and Loss Report',
                      path: '/userdashboard/accounts/report/financialReport/Profit&Loss',
                      // disabled:!permission?.accounts?.report?.financialReport?.profitAndLoss
                    },
                    {
                      key: '/userdashboard/accounts/report/financialReport/GstrReport',
                      label: 'Gstr Report',
                      path: '/userdashboard/accounts/report/financialReport/GstrReport',
                      // disabled:!permission?.accounts?.report?.financialReport?.profitAndLoss
                    }
                  ].filter(Boolean),
                },
                {
                  key:'accountsReportPartnerReports',
                  label: 'Partner Reports',
                  children:[
                    permission?.accounts?.report?.partnerReports?.accountPayable &&
                    {
                      key: '/userdashboard/accounts/report/partnerReport/accountPayable',
                      label: 'Account Payable',
                      path: '/userdashboard/accounts/report/partnerReport/accountPayable',
                      // disabled:!permission?.accounts?.report?.partnerReports?.accountPayable
                    },
                    permission?.accounts?.report?.partnerReports?.accountReceivable &&
                    {
                      key: '/userdashboard/accounts/report/partnerReport/accountReceivable',
                      label: 'Account Receivable',
                      path: '/userdashboard/accounts/report/partnerReport/accountReceivable',
                      // disabled:!permission?.accounts?.report?.partnerReports?.accountReceivable
                    },
                    permission?.accounts?.report?.partnerReports?.agingReportReceivable &&
                    {
                      key: '/userdashboard/accounts/report/partnerReport/AccountReceivableAgingReport',
                      label: 'Aging Report Receivable ',
                      path: '/userdashboard/accounts/report/partnerReport/AccountReceivableAgingReport',
                      // disabled:!permission?.accounts?.report?.partnerReports?.agingReportReceivable

                    },
                    permission?.accounts?.report?.partnerReports?.agingReportPayable &&
                    {
                      key: '/userdashboard/accounts/report/partnerReport/AccountPayableAgingReport',
                      label: 'Aging Report Payable ',
                      path: '/userdashboard/accounts/report/partnerReport/AccountPayableAgingReport',
                      // disabled:!permission?.accounts?.report?.partnerReports?.agingReportPayable

                    },
                    permission?.accounts?.report?.partnerReports?.receivableDueReport &&
                    {
                      key: '/userdashboard/accounts/report/partnerReport/ReceivableDueReport',
                      label: 'Receivable Due Report',
                      path: '/userdashboard/accounts/report/partnerReport/ReceivableDueReport',
                      // disabled:!permission?.accounts?.report?.partnerReports?.receivableDueReport
                      
                    },
                    permission?.accounts?.report?.partnerReports?.payableDueReport &&
                    {
                      key: '/userdashboard/accounts/report/partnerReport/PayableDueReport',
                      label: 'Payable Due Report',
                      path: '/userdashboard/accounts/report/partnerReport/PayableDueReport',
                      // disabled:!permission?.accounts?.report?.partnerReports?.payableDueReport
                      
                    }
                  ].filter(Boolean),
                },
                {
                  key:'accountsReportGeneralReports',
                  label: 'General Reports',
                  children:[
                    permission?.accounts?.report?.generalReport?.bankAndCash &&
                    {
                      key: '/userdashboard/accounts/report/generalReport/bankAndCashReport',
                      label: 'Bank & Cash Report',
                      path: '/userdashboard/accounts/report/generalReport/bankAndCashReport',
                      // disabled:!permission?.accounts?.report?.generalReport?.bankAndCash
                    },
                    permission?.accounts?.report?.generalReport?.chequeRegister &&
                    {
                      key: '/userdashboard/accounts/report/generalReport/ChequeRegisterReport',
                      label: 'Cheque Register Report',
                      path: '/userdashboard/accounts/report/generalReport/ChequeRegisterReport',
                      // disabled:!permission?.accounts?.report?.generalReport?.chequeRegister
                    },
                    permission?.accounts?.report?.generalReport?.invoiceMargin &&
                    {
                      key: '/userdashboard/accounts/report/generalReport/InvoiceMarginReport',
                      label: 'Invoice Margin Report',
                      path: '/userdashboard/accounts/report/generalReport/InvoiceMarginReport',
                      // disabled:!permission?.accounts?.report?.generalReport?.invoiceMargin
                      
                    },
                    permission?.accounts?.report?.generalReport?.productMargin &&
                    {
                      key: '/userdashboard/accounts/report/generalReport/productMarginReport',
                      label: 'Product Margin Report',
                      path: '/userdashboard/accounts/report/generalReport/productMarginReport',
                      // disabled:!permission?.accounts?.report?.generalReport?.productMargin
                    },
                    permission?.accounts?.report?.generalReport?.customerReciept &&
                    {
                      key: '/userdashboard/sales/Report/CustomerReceiptReport',
                      label: 'Customer Receipt Report',
                      path: '/userdashboard/sales/Report/CustomerReceiptReport',
                      // disabled:!permission?.accounts?.report?.generalReport?.customerReciept

                    }
                  ]
                }
              ].filter(Boolean),
            },
            (permission?.accounts?.configuration || userRole==="user") &&
            {
              key:'/userdashboard/accounts/configuration',
              label: 'Configuration',
              path:'/userdashboard/accounts/configuration',
              // disabled: (!permission?.accounts?.configuration || userRole==="user")
              
            }
          ].filter(Boolean),
        },
           permission?.payroll && {
      key: "payroll",
      label: "Payroll",
      icon: <AccountBalanceWalletIcon />,
      children: [
        permission?.payroll?.dashboard && {
          key: "/userdashboard/payroll/dashboard",
          label: "Dashboard",
          path: "/userdashboard/payroll/dashboard",
        },
        permission?.payroll?.setupWizard && {
          key: "/userdashboard/payroll/setup-wizard",
          label: "Setup Wizard",
          path: "/userdashboard/payroll/setup-wizard",
        },
        permission?.payroll?.paySlip && {
          key: "/userdashboard/payroll/paySlip",
          label: "Pay Slip",
          path: "/userdashboard/payroll/paySlip",
        },
        permission?.payroll?.computePayslip && {
          key: "/userdashboard/payroll/compute-payslip",
          label: "Compute Payslip",
          path: "/userdashboard/payroll/compute-payslip",
        },
        permission?.payroll?.payslipList && {
          key: "/userdashboard/payroll/payslips",
          label: "Payslip List",
          path: "/userdashboard/payroll/payslips",
        },
        permission?.payroll?.batchPayslip && {
          key: "/userdashboard/payroll/batchPayslip",
          label: "Batch Payslip",
          path: "/userdashboard/payroll/batchPayslip",
        },
        permission?.payroll?.batchPayslipNew && {
          key: "/userdashboard/payroll/compute-batch",
          label: "Batch Payslip (New)",
          path: "/userdashboard/payroll/compute-batch",
        },
        permission?.payroll?.salaryDisbursement && {
          key: "/userdashboard/payroll/salaryDisbursement",
          label: "Salary Disbursement",
          path: "/userdashboard/payroll/salaryDisbursement",
        },
        // {
        //   key: "/userdashboard/payroll/contractPayslip",
        //   label: "Contract ",
        //   path: "/userdashboard/payroll/contractPayslip",
        //   // disabled:!permission?.payroll?.contractPayslip
        // },
        // {
        //   key: "/userdashboard/payroll/sponsorPayslip",
        //   label: "Sponsor ",
        //   path: "/userdashboard/payroll/sponsorPayslip",
        //   // disabled:!permission?.payroll?.sponsorPayslip
        // },
        permission?.payroll?.variableAndRecurring && {
          key: "/userdashboard/payroll/variableAndRecurring",
          label: "Variable & Recurring ",
          path: "/userdashboard/payroll/variableAndRecurring",
          children: [
            permission?.payroll?.variableAndRecurring?.allowance && {
              key: "/userdashboard/payroll/variableAndRecurring/allowance",
              label: "Allowance ",
              path: "/userdashboard/payroll/variableAndRecurring/allowance",
              children: [
                permission?.payroll?.variableAndRecurring?.allowance?.variableAllowance && {
                  key: "/userdashboard/payroll/variableAndRecurring/allowance/variable",
                  label: "Variable",
                  path: "/userdashboard/payroll/variableAndRecurring/allowance/variable",
                },
                permission?.payroll?.variableAndRecurring?.allowance?.recurringAllowance && {
                  key: "/userdashboard/payroll/variableAndRecurring/allowance/recurring",
                  label: "Recurring",
                  path: "/userdashboard/payroll/variableAndRecurring/allowance/recurring",
                },
              ].filter(Boolean),
            },
            permission?.payroll?.variableAndRecurring?.deduction && {
              key: "/userdashboard/payroll/variableAndRecurring/deduction",
              label: "Deduction ",
              path: "/userdashboard/payroll/variableAndRecurring/deduction",
              children: [
                permission?.payroll?.variableAndRecurring?.deduction?.variableDeduction && {
                  key: "/userdashboard/payroll/variableAndRecurring/deduction/variable",
                  label: "Variable",
                  path: "/userdashboard/payroll/variableAndRecurring/deduction/variable",
                },
                permission?.payroll?.variableAndRecurring?.deduction?.recurringDeduction && {
                  key: "/userdashboard/payroll/variableAndRecurring/deduction/recurring",
                  label: "Recurring",
                  path: "/userdashboard/payroll/variableAndRecurring/deduction/recurring",
                },
              ].filter(Boolean),
            },
          ].filter(Boolean),
        },
        // {
        //   key: "/userdashboard/payroll/loan",
        //   label: "Loan ",
        //   path: "/userdashboard/payroll/loan",
        //   // disabled:!permission?.payroll?.loan
        //   children: [
        //     {
        //       key: "/userdashboard/payroll/loan/loanPayroll",
        //       label: "Loan Payroll",
        //       path: "/userdashboard/payroll/loan/loanPayroll",
        //       // disabled:!permission?.payroll?.loanPayroll
        //     },
        //     {
        //       key: "/userdashboard/payroll/loan/loanEligibility",
        //       label: "Loan Eligibility",
        //       path: "/userdashboard/payroll/loan/loanEligibility",
        //       // disabled:!permission?.payroll?.loanEligibility
        //     },
        //   ],
        // },
        permission?.payroll?.attendance && {
          key: "/userdashboard/payroll/attendance",
          label: "Attendance ",
          path: "/userdashboard/payroll/attendance",
          children: [
            permission?.payroll?.attendance?.attendanceDashboard && {
              key: "/userdashboard/payroll/attendance/attendancePayroll",
              label: "Attendance Dashboard",
              path: "/userdashboard/payroll/attendance/attendancePayroll",
            },
            permission?.payroll?.attendance?.attendanceList && {
              key: "/userdashboard/payroll/attendance/settings",
              label: "Attendance List",
              path: "/userdashboard/payroll/attendance/settings",
            },
            permission?.payroll?.attendance?.leaveManagement && {
              key: "/userdashboard/payroll/attendance/payrollLeave",
              label: "Leave Management",
              path: "/userdashboard/payroll/attendance/payrollLeave",
            },
            permission?.payroll?.attendance?.shiftManagement && {
              key: "/userdashboard/payroll/attendance/EossPayroll",
              label: "Shift Management",
              path: "/userdashboard/payroll/attendance/EossPayroll",
            },
          ].filter(Boolean),
        },
        permission?.payroll?.configuration && {
          key: "/userdashboard/payroll/configuration",
          label: "Configuration",
          path: "/userdashboard/payroll/configuration",
          children: [
            permission?.payroll?.configuration?.payrollSettings && {
              key: "/userdashboard/payroll/configuration/PayrollSettings",
              label: "Payroll Settings",
              path: "/userdashboard/payroll/configuration/PayrollSettings",
            },
            permission?.payroll?.configuration?.salaryStructure && {
              key: "/userdashboard/payroll/configuration/PayrollPayHead",
              label: "Salary Structure",
              path: "/userdashboard/payroll/configuration/PayrollPayHead",
            },
            permission?.payroll?.configuration?.leaveTypes && {
              key: "/userdashboard/payroll/configuration/PayTemplatePayroll",
              label: "Leave Types",
              path: "/userdashboard/payroll/configuration/PayTemplatePayroll",
            },
            permission?.payroll?.configuration?.holidayCalendar && {
              key: "/userdashboard/payroll/configuration/HolidayCalendar",
              label: "Holiday Calendar",
              path: "/userdashboard/payroll/configuration/HolidayCalendar",
            },
          ].filter(Boolean),
        },
      ].filter(Boolean),
    },
        {
          key:'staff',
          label: 'Staff',
          icon:<ManageAccountsOutlined/>,
          children:[
            {
              key:'staffHRM',
              label: 'HRM',
              children:[
                {
                  key: '/userdashboard/staff/hrm/dashboard',
                  label: 'Dashboard',
                  path: '/userdashboard/staff/hrm/dashboard',
                },
                permission?.staff?.hrm?.department && 
                {
                  key: '/userdashboard/staff/hrm/department',
                  label: 'Department',
                  path: '/userdashboard/staff/hrm/department',
                  // disabled:!permission?.staff?.hrm?.department
                },
                permission?.staff?.hrm?.designation &&
                {
                  key: '/userdashboard/staff/hrm/designation',
                  label: 'Designation',
                  path: '/userdashboard/staff/hrm/designation',
                  // disabled:!permission?.staff?.hrm?.designation
                },
                permission?.staff?.hrm?.manageEmployee &&
                {
                  key: '/userdashboard/staff/hrm/manageEmployee',
                  label: 'Manage Employee',
                  path: '/userdashboard/staff/hrm/manageEmployee',
                  // disabled:!permission?.staff?.hrm?.manageEmployee
                },
                permission?.staff?.hrm?.addEmployee &&
                {
                  key: '/userdashboard/staff/hrm/addEmployee',
                  label: 'Add Employee',
                  path: '/userdashboard/staff/hrm/addEmployee',
                  // disabled:!permission?.staff?.hrm?.addEmployee
                  
                },
                permission?.staff?.hrm?.addDocument && 
                {
                  key: '/userdashboard/staff/hrm/addDocument',
                  label: 'Add Document',
                  path: '/userdashboard/staff/hrm/addDocument',
                  // disabled:!permission?.staff?.hrm?.addDocument
                },
                // Employee Transition & Performance Management - Added Nov 2024
                permission?.staff?.hrm?.employeeTransitions && {
                  key: '/userdashboard/staff/hrm/transitions',
                  label: 'Employee Transitions',
                  path: '/userdashboard/staff/hrm/transitions',
                },
                permission?.staff?.hrm?.manageEmployee && {
                  key: '/userdashboard/staff/hrm/tasks',
                  label: 'Employee Tasks',
                  path: '/userdashboard/staff/hrm/tasks',
                },
                permission?.staff?.performanceManagement && {
                  key: 'performanceManagement',
                  label: 'Performance Management',
                  children: [
                    permission?.staff?.performanceManagement?.dashboard && {
                      key: '/userdashboard/staff/hrm/performance/dashboard',
                      label: 'Dashboard',
                      path: '/userdashboard/staff/hrm/performance/dashboard',
                    },
                    permission?.staff?.performanceManagement?.kpiManagement && {
                      key: '/userdashboard/staff/hrm/performance/kpi',
                      label: 'KPI Management',
                      path: '/userdashboard/staff/hrm/performance/kpi',
                    },
                    permission?.staff?.performanceManagement?.createReview && {
                      key: '/userdashboard/staff/hrm/performance/review/create',
                      label: 'Create Review',
                      path: '/userdashboard/staff/hrm/performance/review/create',
                    },
                    permission?.staff?.performanceManagement?.viewReviews && {
                      key: '/userdashboard/staff/hrm/performance/review/list',
                      label: 'View Reviews',
                      path: '/userdashboard/staff/hrm/performance/review/list',
                    },
                    permission?.staff?.performanceManagement?.pipManagement && {
                      key: '/userdashboard/staff/hrm/performance/pip',
                      label: 'PIP Management',
                      path: '/userdashboard/staff/hrm/performance/pip',
                    },
                    permission?.staff?.performanceManagement?.goals && {
                      key: '/userdashboard/staff/hrm/performance/goals',
                      label: 'Goals',
                      path: '/userdashboard/staff/hrm/performance/goals',
                    },
                  ].filter(Boolean),
                },
                permission?.staff?.hrm?.assetManagement && {
                  key: '/userdashboard/staff/hrm/assets',
                  label: 'Asset Management',
                  path: '/userdashboard/staff/hrm/assets',
                }
              ].filter(Boolean),
            }
          ].filter(Boolean),
        },
        (permission?.crm?.all || permission?.crm?.dashboard || permission?.crm?.campaigns) && {
          key: 'crm',
          label: 'CRM',
          icon: <LoyaltyIcon />,
          children: [
            (permission?.crm?.all || permission?.crm?.dashboard) && {
              key: '/userdashboard/crm/dashboard',
              label: 'Dashboard',
              path: '/userdashboard/crm/dashboard',
            },
            (permission?.crm?.all || permission?.crm?.campaigns) && {
              key: '/userdashboard/crm/campaigns',
              label: 'AI Campaigns',
              path: '/userdashboard/crm/campaigns',
            }
          ].filter(Boolean)
        },
        permission?.deviceSettings &&
        {
          key:'/userdashboard/Devicesettings',
          label: 'Device Settings',
          icon:<SettingsBrightnessIcon/>,
          path:'/userdashboard/Devicesettings',
          // disabled:!permission?.deviceSettings
        },
        permission?.staff?.notifications && {
          key: 'notifications',
          label: 'Notifications',
          icon: <NotificationsActiveIcon/> ,
          children: [
            permission?.staff?.notifications?.notificationCenter && {
              key: '/userdashboard/staff/hrm/notifications',
              label: 'Notification Center',
              path: '/userdashboard/staff/hrm/notifications',
            },
            permission?.staff?.notifications?.preferences && {
              key: '/userdashboard/staff/hrm/notifications/preferences',
              label: 'Preferences',
              path: '/userdashboard/staff/hrm/notifications/preferences',
            },
            permission?.staff?.notifications?.pushSetup && {
              key: '/userdashboard/staff/hrm/notifications/push-setup',
              label: 'Push Setup',
              path: '/userdashboard/staff/hrm/notifications/push-setup',
            },
            permission?.staff?.notifications?.settings && {
              key: '/userdashboard/staff/hrm/notifications/settings',
              label: 'Settings',
              path: '/userdashboard/staff/hrm/notifications/settings',
            },
            permission?.staff?.notifications?.auditLogs && {
              key: '/userdashboard/staff/hrm/notifications/audit-logs',
              label: 'Audit Logs',
              path: '/userdashboard/staff/hrm/notifications/audit-logs',
            },
          ].filter(Boolean),
        },
        userRole === "admin" && {
          key: '/userdashboard/ecommerce/seller',
          label: 'Ecommerce Store',
          icon: <StorefrontOutlinedIcon />,
          path: '/userdashboard/ecommerce/seller',
        },
        // Security & RBAC Management (Admin only)
        userRole === "admin" && {
          key: 'security',
          label: 'Security',
          icon: <SecurityIcon/>,
          children: [
            {
              key: '/userdashboard/system/rbac-management',
              label: 'RBAC Management',
              path: '/userdashboard/system/rbac-management',
            },
            {
              key: '/userdashboard/system/roles-permissions',
              label: 'Roles & Permissions',
              path: '/userdashboard/system/roles-permissions',
            },
          ].filter(Boolean),
        },
        permission?.generateQrBarcode &&
        {
          key:'/userdashboard/qr/barcode',
          label: 'Generate QR/Barcode',
          icon:<QrCodeScannerOutlinedIcon/>,
          path:'/userdashboard/qr/barcode',
          // disabled:!permission?.generateQrBarcode
        },
        {
          key:'/userdashboard/settings',
          label: 'Settings',
          icon:<SettingsOutlined/>,
          path:'/userdashboard/settings',
          hideMenu:userRole==="user"
        }
      ].filter(Boolean); ;

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);


    };
    const navigate = useNavigate();
   
    const handleClick = (e) => {
     
        navigate(e.key);
    store.dispatch(get_check_out(null));
       

    };
    const location = useLocation();
    const [selectedKeys, setSelectedKeys] = useState([location.pathname]);


    const removeHiddenMenus = (items) => {
      return items?.reduce((filteredItems, item) => {
        // Skip falsy items (false, null, undefined)
        if (!item) {
          return filteredItems;
        }
        
        if (item?.hideMenu) {
          return filteredItems; // Skip items with hideMenu: true
        }
        
        // Create a clean copy without hideMenu property
        const { hideMenu, ...cleanItem } = item;
        
        // If the item has children, apply the function recursively
        if (cleanItem?.children) {
          cleanItem.children = removeHiddenMenus(cleanItem.children);
        }
    
        // Push the current item to the result array
        filteredItems?.push(cleanItem);
        return filteredItems;
      }, []);
    };
    
    const finalMenu = removeHiddenMenus(items);
    useEffect(() => {

        setSelectedKeys([location.pathname]);

    }, [location.pathname]);


    useEffect(() => {
      const handleClickOutside = (event) => {
          if (
              sideMenuRef.current &&
              !sideMenuRef.current.contains(event.target)
          ) {
              setCollapsed(true)
          }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
          document.removeEventListener("mousedown", handleClickOutside);
      };
  }, []);

  return (
    <div className='sidemenu-ant-ctn' ref={sideMenuRef}>
        <div style={{position:"relative"}}>

        <Button
        type="primary"
        onClick={toggleCollapsed}
        className='menu-expand-btn'
      >
        {collapsed ? ">" : "<"}
      </Button>
      <Menu
        onClick={handleClick}
        // defaultOpenKeys={['sub3','sub2']}
        selectedKeys={selectedKeys}
        mode="inline"
        theme="light"
        inlineCollapsed={collapsed}
        items={finalMenu}
        className='ant-menu'
        style={{
          width:collapsed?"60px":"fit-content",
          boxShadow:collapsed?"none":"0 8px 16px rgba(0,0,0,0.3)",

        }}
      />

    </div>

    </div>
  )
}

export default SideMenuUpdated